<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="title"></a><a id="page_iii"></a><em>Wedding Belles</em></h1>
<p class="center"><img alt="Image" src="images/title2.jpg"/></p>
<p class="author"><span class="small">HAYWOOD SMITH</span></p>
<p class="center3"><img alt="Image" src="images/title.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?33d7ecf4